<template>
  <div class="WHInherit">
    <div :style="{ width: VW(width), height: VW(height) }" v-if="url">
      <a v-if="a" :href="url" style="color: #0d84ff">{{ aText }}</a>
      <el-image
        v-else-if="isImg"
        class="WHInherit"
        :preview-src-list="urlList || [url]"
        :src="url"
      />
      <div
        v-else
        class="pointer preview-iframe WHInherit"
        @click="previewDialog = true"
      >
        <video v-if="isVideo" controls class="LT WHInherit" :style="{ 'pointer-events': popView ? 'none' : 'auto' }">
          <source :src="url">
        </video>
        <iframe
          v-else
          :src="iframeUrl"
          class="WHInherit"
          :style="{ 'pointer-events': popView ? 'none' : 'auto' }"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="previewDialog"
      fullscreen
      append-to-body
      width="fit-content"
      custom-class="preview-dialog"
    >
      <div class="flex-center" style="height: 85vh">
        <video controls style="width: 80vw" v-if="isVideo">
          <source :src="url">
        </video>
        <iframe v-else :src="iframeUrl" style="width: 80vw; height: inherit"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {fileLinkFileType, type} from "otb-module/src/utils/tool";

export default {
  name: "hPreview",
  props: {
    a: {
      type: Boolean,
      default: false
    },
    aText: {
      type: String,
      default: "查看",
    },
    url: {
      type: String
    },
    urlList: {
      type: Array
    },
    width: {
      type: [String, Number],
      default: 1.5
    },
    height: {
      type: [String, Number],
      default: 1.5
    },
    popView: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      fileType: "",
      previewDialog: false
    };
  },
  computed: {
    VW() {
      return (v) => {
        if (type(v) === "Number") return `${v}vw`
        return v
      }
    },
    iframeUrl() {
      if (["pdf", 'txt'].includes(this.fileType)) {
        return this.url;
      }
      return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.url)}`;
    },
    isImg() {
      return ['jpg', 'jpeg', 'png', "gif"].includes(this.fileType);
    },
    isVideo() {
      return ['mp4', 'm3u8', 'avi', 'mov', 'wmv', 'flv', 'mkv', '3gp'].includes(this.fileType);
    },
  },
  watch: {
    url: {
      handler(newVal) {
        if (newVal) this.fileType = fileLinkFileType(newVal)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.LT {
  object-fit: cover;
  object-position: left top;
}

::v-deep .el-image img {
  max-width: 65vw;
  @extend .LT
}

iframe {
  border-width: 0;
  background-color: #ffffff;
}
</style>

<style lang="scss">
.preview-dialog {
  background-color: transparent;
  box-shadow: none;

  .el-dialog__headerbtn {
    top: 35px;
    right: 35px;

    i {
      background-color: #606266;
      border-radius: 50%;
      padding: 10px;
      font-size: 25px;
      color: #ffffff;
    }

    &:hover i {
      color: #ffffff;
    }
  }
}
</style>
